import { Flex, Text, type FlexProps, type TagsInputProps } from '@mantine/core';
import classes from './FormActivitySphereTagsInput.module.scss';
import { ActivitySphereTagsInput } from '@entities/activitySphere';

interface FormActivitySphereTagsInputProps extends TagsInputProps {
  title?: string;
  description?: string;
  containerProps?: FlexProps;
}

export const FormActivitySphereTagsInput = ({
  title = 'Сфера деятельности',
  description = 'Выберите все сферы деятельности компании',
  placeholder = 'Выберите',
  containerProps,
  ...props
}: FormActivitySphereTagsInputProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <ActivitySphereTagsInput
        {...props}
        placeholder={placeholder}
        className={classes.rightColumn}
        variant='filled'
      />
    </Flex>
  );
};
